import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const stackedCards = () => {
	const cards = gsap.utils.toArray('.gsap-block');
	if (!cards.length) return;

	const lastCardIndex = cards.length - 1;

	const lastCardST = ScrollTrigger.create({
		trigger: cards[lastCardIndex],
		start: 'top 130'
	});

	cards.forEach((card, index) => {
		let scale = 1;
		let rotation = 0;

		if (index !== lastCardIndex) {
			scale = 0.9 + 0.025 * index;
			rotation = -10;
		}

		const scaleDown = gsap.to(card, {
			scale,
			rotationX: rotation,
			transformOrigin: 'top center',
			ease: 'none'
		});

		ScrollTrigger.create({
			trigger: card,
			start: `top ${130 + 25 * index}`,
			end: () => lastCardST.start - 75,
			pin: true,
			pinSpacing: false,
			scrub: 0.5,
			animation: scaleDown,
			toggleActions: 'restart none none reverse'
		});
	});
};

export default stackedCards;